export default __webpack_public_path__ + "static/media/LENS_CULINARIS_TEKAY_fragment_7.cda58702.jpg";